import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { ProfileInfoUpdate, ProfilePictureUpdate } from '../components/profile/basicInfoTab';
import { UpdatePassword } from '../components/profile/passwordTab';
import { ResetPasswordRequest } from '../pages/resetPassword';
import { getResetPasswordToken, resetPassword, updatePassword, updateProfile, updateProfilePicture } from '../services/profile.service';

export interface ProfileState {
  legalName: string | null,
  callingName: string | null,
  emailAddress: string | null,
  imageUrl: string | null,
  location: any | null,
  mobileNumber: string | null,
  isEmailVerified: string | null,
  isMobileVerified: string | null,
  countryId: number | null,
}

const initialState: ProfileState = {
  legalName: JSON.parse(localStorage.getItem('auth')!)?.legalName,
  callingName: JSON.parse(localStorage.getItem('auth')!)?.callingName,
  emailAddress: JSON.parse(localStorage.getItem('auth')!)?.emailAddress,
  imageUrl: JSON.parse(localStorage.getItem('auth')!)?.imageUrl,
  location: JSON.parse(localStorage.getItem('auth')!)?.location,
  mobileNumber: JSON.parse(localStorage.getItem('auth')!)?.mobileNumber,
  isEmailVerified: JSON.parse(localStorage.getItem('auth')!)?.isEmailVerified,
  isMobileVerified: JSON.parse(localStorage.getItem('auth')!)?.isMobileVerified,
  countryId: JSON.parse(localStorage.getItem('auth')!)?.countryId,
};

export const updateProfileAsync = createAsyncThunk(
  'profile/updateProfile',
  async (data: any) => {
    try {
      const profileInfoUpdate: ProfileInfoUpdate = {
        legalName: data.legalName,
        callingName: data.callingName,
        countryId: data.countryId,
        mobileNumber: data.mobileNumber,
      }
      const response = await updateProfile(data.id, profileInfoUpdate);
      const responseStatus = response?.status;
      return { ...profileInfoUpdate, responseStatus };
    }
    catch (error) {
      console.log(`error occurred`);
    }
  }
);

export const updateProfilePictureAsync = createAsyncThunk(
  'profile/updateProfilePicture',
  async (data: any) => {
    try {
      const profilePictureUpdateRequest: ProfilePictureUpdate = {
        imageUrl: data.imageUrl,
      }
      const response = await updateProfilePicture(data.id, profilePictureUpdateRequest);
      const responseStatus = response?.status;
      return { ...profilePictureUpdateRequest, responseStatus };
    }
    catch (error) {
      console.log(`error occurred`);
    }
  }
);

export const upddatePasswordAsync = createAsyncThunk(
  'profile/updatePassword',
  async (data: any) => {
    const updatePasswordRequest: UpdatePassword = {
      username: data.username,
      currentPassword: data.currentPassword,
      newPassword: data.newPassword,
    }
    const response = await updatePassword(updatePasswordRequest);
    //window.location.reload();
    const responseStatus = response?.status;
    console.log(`Change password status : ${responseStatus}`);
    return responseStatus;
  }
);

export const resetPasswordAsync = createAsyncThunk(
  'profile/resetPassword',
  async (data: any) => {
    const resetPasswordRequest: ResetPasswordRequest = {
      username: data.username,
      resetPasswordToken: data.resetPasswordToken,
      newPassword: data.newPassword,
    }
    const response = await resetPassword(resetPasswordRequest);
    const responseStatus = response?.status;
    return responseStatus;
  }
);

export const getResetPasswordTokenAsync = createAsyncThunk(
  'profile/getResetPasswordToken',
  async (data: any) => {
    const response = await getResetPasswordToken(data.username);
    const responseStatus = response?.status;
    return responseStatus;
  }
);

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateProfileAsync.pending, (state) => {
      })
      .addCase(updateProfileAsync.fulfilled, (state, action) => {
        console.log(`Action : ${JSON.stringify(action.payload)}`);
        if (action.payload && action.payload.responseStatus) {
          const currentLocalStorage = JSON.parse(localStorage.getItem('auth')!);
          const newLocalStorage = {
            ...currentLocalStorage,
            legalName: action.payload.legalName,
            callingName: action.payload.callingName,
            countryId: action.payload.countryId,
          }
          localStorage.setItem('auth', JSON.stringify(newLocalStorage));
          state.callingName = action.payload.callingName;
          state.legalName = action.payload.legalName;
          state.countryId = action.payload.countryId;
        }
      })
      .addCase(updateProfileAsync.rejected, (state) => {
      })
      .addCase(updateProfilePictureAsync.pending, (state) => {
      })
      .addCase(updateProfilePictureAsync.fulfilled, (state, action) => {
        if (action.payload && action.payload.responseStatus) {
          const currentLocalStorage = JSON.parse(localStorage.getItem('auth')!);
          const newLocalStorage = {
            ...currentLocalStorage,
            imageUrl: action.payload.imageUrl,
          }
          localStorage.setItem('auth', JSON.stringify(newLocalStorage));
          state.imageUrl = action.payload.imageUrl;
        }
      })
      .addCase(updateProfilePictureAsync.rejected, (state) => {
        console.log(`rejected`);
      });
  },
});

export const selectProfile = (state: RootState): ProfileState => {
  return { ...state.profile }
}

export default profileSlice.reducer;